/**
 * The release this browser has asked not to be nagged about. Per browser on purpose: skipping
 * changes only what nags, never what the fleet does, so it needs no backend write. Storage can
 * be blocked, which reads as no skip. `RESET` clears the skip.
 */

import { atomWithStorage } from 'jotai/utils';

import { textStorage } from '../storage';
import { localStore } from '@/lib/webStorage';

export const skippedVersionAtom = atomWithStorage<string | null>(
    'occurra.updates.skippedVersion', null, textStorage(localStore), { getOnInit: true });
